import './restore-keys-tab.scss';
import {
  UiInput,
  UiSelect,
  Table,
  Loader,
} from '@ru-digital-assets/ui-component';
import { SearchIcon } from 'assets/icons';
import { useState, useCallback, useEffect } from 'react';
import { debounce } from 'lodash';
import { OptionType } from '@ru-digital-assets/ui-component/dist/stories/ui/ui-select/ui-select';
import { RowComponent, getColumns } from './components';
import { useDispatch, useSelector } from 'hooks/redux';
import OperatorAPI from 'services/api/Operator';
import { setPush } from 'store/actions/app';
import { KeyRecoveryStatus } from 'constants/key-recovery';

export default function RestoreKeysTab() {
  const dispatch = useDispatch();
  const token = useSelector((s) => s.auth.account.token);

  const [searchParams, setSearchParams] = useState({
    search: '',
    status: undefined,
  });

  const [keys, setKeys] = useState();
  const [loading, setLoading] = useState(false);

  const onSearchChange = useCallback(
    debounce((e: React.ChangeEvent<HTMLInputElement>) => {
      setSearchParams((searchParams) => ({
        ...searchParams,
        search: e.target.value,
      }));
    }, 300),
    []
  );

  useEffect(() => {
    setLoading(true);
    OperatorAPI.getRecoveries(token, searchParams.status)
      .then((response) => {
        setKeys(response.data);
      })
      .catch(() => {
        dispatch(
          setPush({
            type: 'error',
            message: 'Не удалось загрузить информацию о заявках на восстановление ключа',
          })
        );
      })
      .finally(() => {
        setLoading(false);
      });
  }, [searchParams]);

  return (
    <div className="restore-keys-tab">
      <div className="flex ml_16">
        <div className="mr_16" style={{ minWidth: '280px' }}>
          <UiInput
            label="Поиск по пользователям"
            sm
            leftIcon={<SearchIcon color="#444" />}
            onChange={onSearchChange}
          />
        </div>
        <div className="mr_16" style={{ minWidth: '180px' }}>
          <UiSelect
            placeholder={'Статус'}
            sm
            options={[
              {
                label: 'Не выбрано',
                value: null,
              },
              {
                label: 'Подписание',
                value: KeyRecoveryStatus.INIT,
              },
              {
                label: 'Восстановлен',
                value: KeyRecoveryStatus.SIGNED,
              },
            ]}
            onChange={(selected) => {
              if (selected) {
                setSearchParams((searchParams) => ({
                  ...searchParams,
                  status: (selected as OptionType).value,
                }));
              }
            }}
          />
        </div>
      </div>
      {loading || !keys ? (
        <div className="flex justify-center mt_32">
          <Loader />
        </div>
      ) : (
        <div className="mt_16">
          <Table
            loading={false}
            data={keys}
            columns={getColumns()}
            RowComponent={RowComponent}
            showHeaderBottomLine
          />
        </div>
      )}
    </div>
  );
}
